import request from "../utils/request.js"
// 获取托管服务列表
export function getTrustListApi(params) {
    return request({
        url: "/trust/list",
        method: "post",
        data: params,
    })
}
// 获取服务类型列表
export function getTrustTypeApi() {
    return request({
        url: "/trust/getTrustType",
        method: "get"
    })
}
// 获取托管服务详情及合同附件
export function getServiceDetailApi(id) {
    return request({
        url: "/trust/detail/"+id,
        method: "get"
    })
}
// 保存托管服务
export function saveTrustApi(params) {
    return request({
        url: "/trust/saveTrust",
        method: "post",
        data: params,
    })
}